export default "__VITE_ASSET__D61J12t2__"